import type { MainContentTab } from '../store/layoutStore';
import {
  ASSET_TYPE,
  type AssetType,
} from '../store/tab/assetsTabScopedFilterStore';

export const DOMAIN_TREE_FILTER_TABS = [
  'signals-list',
  'assets-list',
  'executions-list',
] as const satisfies readonly MainContentTab[];

export type DomainTreeFilterTab = (typeof DOMAIN_TREE_FILTER_TABS)[number];

export function isDomainTreeFilterTab(
  tabType: MainContentTab | undefined,
): tabType is DomainTreeFilterTab {
  return (
    tabType !== undefined &&
    DOMAIN_TREE_FILTER_TABS.includes(tabType as DomainTreeFilterTab)
  );
}

export function resolveActiveTabDomainTreeQueryOptions({
  activeTabType,
  assetTypeFilter,
}: {
  activeTabType: MainContentTab | undefined;
  assetTypeFilter: AssetType | undefined;
}) {
  if (activeTabType === 'assets-list' && assetTypeFilter) {
    return getAssetsDomainTreeQueryOptions(assetTypeFilter);
  }

  if (activeTabType === 'executions-list') {
    return getExecutionsDomainTreeQueryOptions();
  }

  if (activeTabType === 'signals-list') {
    return getSignalsDomainTreeQueryOptions();
  }

  return getAssetsDomainTreeQueryOptions(ASSET_TYPE.ENDPOINTS);
}

const DOMAIN_TREE_TYPE_BY_ASSET_TYPE = {
  [ASSET_TYPE.ALL]: 'ALL',
  [ASSET_TYPE.ENDPOINTS]: 'ALL',
  [ASSET_TYPE.WEB_ENDPOINTS]: 'endpoints',
  [ASSET_TYPE.WEB_PAGES]: 'webpages',
  [ASSET_TYPE.AGENTS]: 'agents',
} as const satisfies Record<
  AssetType,
  'ALL' | 'endpoints' | 'webpages' | 'agents'
>;

export function getAssetsDomainTreeQueryOptions(typeFilter: AssetType) {
  return {
    includeMethodNodes: true,
    includeEndpoints: typeFilter !== ASSET_TYPE.WEB_PAGES,
    includeWebPages:
      typeFilter === ASSET_TYPE.WEB_PAGES || typeFilter === ASSET_TYPE.ALL,
    type: DOMAIN_TREE_TYPE_BY_ASSET_TYPE[typeFilter],
  };
}

export function getExecutionsDomainTreeQueryOptions() {
  return {
    includeMethodNodes: false,
    includeEndpoints: true,
    includeWebPages: false,
  };
}

export function getSignalsDomainTreeQueryOptions() {
  return {
    includeMethodNodes: false,
    includeEndpoints: true,
    includeWebPages: false,
  };
}
